module.exports = require("C:\\91APP\\91app-tech-blog\\.gatsby\\gatsby-browser.tsx");